var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBoldCross = function SvgBoldCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.07,
    y: 0.707,
    width: 1,
    height: 9,
    rx: 0.5,
    transform: "rotate(45 7.07 .707)",
    fill: "currentColor",
    stroke: "transparent"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.707,
    y: 1.414,
    width: 1,
    height: 9,
    rx: 0.5,
    transform: "rotate(-45 .707 1.414)",
    fill: "currentColor",
    stroke: "transparent"
  })));
};
export default SvgBoldCross;